import React, { Component } from 'react';
import { string, func, bool } from 'prop-types';
import { connect } from 'react-redux';

import { goToPage, notifications, SET_PAGE_BREAK_ERROR } from 'PipeRouter';
import PageSelectorViews from './views';

class PageSelector extends Component {
    constructor(props) {
      super(props);

      this.state = {
        inputValue: props.currentPageBreak,
        inputFocus: false
      }
    }

    componentDidUpdate(prevProps, prevState) {
      const { currentPageBreak } = this.props;
      const { inputFocus } = this.state;
    
      if (currentPageBreak !== prevProps.currentPageBreak && !inputFocus) {
        this.setState({ inputValue: currentPageBreak !== '' ? currentPageBreak : 'Go to page' });
      }
    }

    handlePageInputChange = event => {
      this.setState({ inputValue: event.target.value });
      if (this.props.pageBreakError) {
        this.props.notifications(SET_PAGE_BREAK_ERROR, {message: null});
      }
    }

    goToPage = event => {
      event.persist();
      if (event.keyCode && event.keyCode === 13) {
        this.props.goToPage(event.target.value);
      }
    }

    handleInputFocus = () => {
      this.setState({ inputFocus: true });
      if (this.props.pageBreakError) {
        this.props.notifications(SET_PAGE_BREAK_ERROR, {message: null});
      }
    }

    handleInputBlur = () => {
      this.setState({ inputFocus: false, inputValue: this.props.currentPageBreak });
      if (this.props.pageBreakError) {
        this.props.notifications(SET_PAGE_BREAK_ERROR, {message: null});
      }
    }

    render() {
      return (
        <PageSelectorViews
          handleInputBlur={this.handleInputBlur}
          handleInputFocus={this.handleInputFocus}
          goToPage={this.goToPage}
          handlePageInputChange={this.handlePageInputChange}
          inputValue={this.state.inputValue}
          pageBreakError={this.props.pageBreakError}
          isMobile={this.props.isMobile}
        />
      );
    }
}

PageSelector.propTypes = {
  currentPageBreak: string,
  pageBreakError: string,
  goToPage: func,
  isMobile: bool
}

function mapStateToProps(state) {
  const { currentPageBreak, isMobile } = state.reader;
  const { pageBreakError } = state.notifications;

  return {
    currentPageBreak,
    pageBreakError,
    isMobile
  };
}

export default connect(mapStateToProps, { goToPage, notifications })(PageSelector);